/*
  LogosDisplay
    - Partner + partners images (admin derived), show this header.
*/

// Libraries

/* Components */
import LogosDisplay from '@components/PageLayouts/Header/Parts/LogosDisplay';

import { PartnerBaseAttributes } from '@integrations/partners/partners.types';

const CoBrandedHeader = ({ partner }: { partner: PartnerBaseAttributes }) => <LogosDisplay partner={partner} classType="cobranded" />;

export default CoBrandedHeader;
